'use strict';

exports.__esModule = true;

var _core = require('@emotion/core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).';
}
/** @jsx jsx */


var highlightedStyling = process.env.NODE_ENV === 'production' ? {
  name: '12fugvv-highlightedStyling',
  styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;'
} : {
  name: '12fugvv-highlightedStyling',
  styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;',
  map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */',
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Highlight = function Highlight(props) {
  var textToHighlight = props.textToHighlight,
      searchWords = props.searchWords,
      autoEscape = props.autoEscape,
      hasPredictiveSuggestion = props.hasPredictiveSuggestion,
      categoryLabel = props.categoryLabel;
  var modSearchWords = searchWords.map(function (word) {
    return autoEscape ? (0, _utils.escapeRegExp)(word) : word;
  }).filter(function (word) {
    return word;
  });
  var stringToReplace = categoryLabel || modSearchWords.join('|');
  return (0, _core.jsx)('div', {
    css: highlightedStyling,
    dangerouslySetInnerHTML: {
      __html: hasPredictiveSuggestion ? textToHighlight : textToHighlight.replace(new RegExp(stringToReplace, 'ig'), function (matched) {
        return '<mark class="highlight">' + matched + '</mark>';
      })
    }
  });
};

Highlight.propTypes = {
  searchWords: _propTypes2.default.arrayOf(_propTypes2.default.string),
  textToHighlight: _propTypes2.default.string,
  autoEscape: _propTypes2.default.bool,
  hasPredictiveSuggestion: _propTypes2.default.bool,
  categoryLabel: _propTypes2.default.string
};
Highlight.defaultProps = {
  searchWords: [],
  textToHighlight: '',
  autoEscape: false,
  hasPredictiveSuggestion: false
};
exports.default = Highlight;